import TeamsTimeline from "app/routes/Teams/TeamsTimeline";
import GroupMembers from "./GroupMembers";
import GroupTimeline from "./GroupTimeline";
import TeamsMembers from "app/routes/Teams/TeamsMembers";

export const groupRoutes = [
  {
    path: "/groups/:id",
    exact: true,
    component: GroupTimeline,
  },
  {
    path: "/groups/:id/members",
    exact: true,
    component: GroupMembers,
  },
  {
    path: "/groups/:id/channels/:teamId",
    exact: true,
    component: TeamsTimeline,
  },
  {
    path: "/groups/:id/channels/:teamId/members",
    exact: true,
    component: TeamsMembers,
  },
];
